import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Без этого при переходе со страницы новостей на карточку новости пользователь
 * попадал в середину новой страницы — react-router позицию скролла не сбрасывает.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
